import React, { useState } from 'react';
import { CenteredPlayButton } from './VideoPlayer/VideoControls';
import styled from 'styled-components';
import { ImageAspectBox16x9 } from './ImageAspectBox/ImageAspectBox';
import Youtube from 'react-youtube';
const Wrapper = styled.div `
  .poster {
    display: ${({ showPoster }) => (showPoster ? 'flex' : 'none')} !important;
  }
  .video {
    display: ${({ showPoster }) => (showPoster ? 'none' : 'flex')};
  }
`;
export const VideoEmbed = ({ url = '', colorSet, }) => {
    const [showPoster, setShowPoster] = useState(true);
    const [player, setPlayer] = useState(null);
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = match && match[2].length === 11 ? match[2] : null;
    const onPlayerReady = event => {
        setPlayer(event.target);
    };
    const onPlayButtonClick = () => {
        setShowPoster(false);
        player === null || player === void 0 ? void 0 : player.playVideo();
    };
    return (React.createElement(Wrapper, { "data-testid": "video-component", showPoster: showPoster },
        React.createElement(ImageAspectBox16x9, { className: "poster", title: "play-button-on-load", style: { height: '100%' } },
            React.createElement("img", { src: `http://img.youtube.com/vi/${videoId}/maxresdefault.jpg`, alt: "poster" }),
            React.createElement(CenteredPlayButton, { play: onPlayButtonClick, colorSet: colorSet })),
        React.createElement(ImageAspectBox16x9, { className: "video" },
            React.createElement(Youtube, { title: "video", videoId: videoId || '', onReady: onPlayerReady, onEnd: () => {
                    if (document.fullscreenElement) {
                        document.exitFullscreen();
                    }
                    setShowPoster(true);
                } }))));
};
